module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-miyazaki-1-694ace78e09107861c6452926bedefee.png";